<template>
  <div class="n_geographical">
    <div ref="container" id="container" class="n_cominty"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  mounted() {
    this.mapFg()
  },
  methods: {
    mapFg() {
      let _this = this
      var map, geolocation
      map = new AMap.Map(this.$refs.container, {
        resizeEnable: true,
      })
      map.plugin(
        ['AMap.Geolocation', 'AMap.Driving', 'AMap.Weather'],
        function () {
          geolocation = new AMap.Geolocation({
            enableHighAccuracy: true, // 是否使用高精度定位，默认:true
            timeout: 10000, // 超过10秒后停止定位，默认：无穷大
            maximumAge: 0, // 定位结果缓存0毫秒，默认：0
            convert: true, // 自动偏移坐标，偏移后的坐标为高德坐标，默认：true
            showButton: true, // 显示定位按钮，默认：true
            buttonPosition: 'LB', // 定位按钮停靠位置，默认：'LB'，左下角
            buttonOffset: new AMap.Pixel(10, 20), // 定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
            showMarker: true, // 定位成功后在定位到的位置显示点标记，默认：true
            showCircle: true, // 定位成功后用圆圈表示定位精度范围，默认：true
            panToLocation: true, // 定位成功后将定位到的位置作为地图中心点，默认：true
            zoomToAccuracy: true, // 定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
          })
          // AMap.LineSearch
          map.addControl(geolocation)
          geolocation.getCurrentPosition()
          AMap.event.addListener(geolocation, 'complete', onComplete) // 返回定位信息
          AMap.event.addListener(geolocation, 'error', onError) // 返回定位出错信息
          var driving = new AMap.Driving({
            // 驾车路线规划策略，AMap.DrivingPolicy.LEAST_TIME是最快捷模式
            policy: AMap.DrivingPolicy.LEAST_TIME,
            map: map,
          })
          driving.search(
            new AMap.LngLat(117.11412, 36.68),
            new AMap.LngLat(116.427281, 39.903719),
            function (status, result) {
              console.log(status, result)
              // result 即是对应的驾车导航信息，相关数据结构文档请参考  https://lbs.amap.com/api/javascript-api/reference/route-search#m_DrivingResult
              if (status === 'complete') {
                console.log('绘制驾车路线完成')
              } else {
                console.log('获取驾车数据失败：' + result)
              }
            }
          )
          //创建天气查询实例
          var weather = new AMap.Weather()
          //执行实时天气信息查询
          weather.getLive('杭州市', function (err, data) {
            console.log(err, data)
          })
        }
      )
      function onComplete(data) {
        console.log(data, '成功')
      }
      //解析定位错误信息
      function onError(data) {
        console.log(data, '失败')
      }
    },
  },
}
</script>

<style scoped>
.n_geographical {
  padding: 20px;
}
.n_cominty {
  width: 100%;
  height: 800px;
}
</style>